import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';

import CardMedia from "@material-ui/core/CardMedia";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import Loading from '../Loading/Loading';
import Resizer from 'react-image-file-resizer';
import DropzoneS3Uploader from 'react-dropzone-s3-uploader'
import UploadDisplay from '../UploadDisplay/UploadDisplay';

import AWS from 'aws-sdk'
import { uploadFile } from 'react-s3';
import axios from 'axios'

const config = {
    bucketName: 'solanas',
    dirName: 'img', /* optional */
    region: 'sa-east-1',
    accessKeyId: 'AKIAIDJS7XGVXOZCKMVQ',
    secretAccessKey: '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'
}

const uploadOptions = {
    server: 'https://getupstudio.co/solanasapi/',
    signingUrlQueryParams: {uploadType: 'avatar'},
}

//https://www.npmjs.com/package/react-s3
const S3_BUCKET ='solanas';
const REGION ='sa-east-1';
const ACCESS_KEY ='AKIAIDJS7XGVXOZCKMVQ';
const SECRET_ACCESS_KEY ='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';

const config2 = {
    bucketName: S3_BUCKET,
    region: REGION,
    accessKeyId: ACCESS_KEY,
    secretAccessKey: SECRET_ACCESS_KEY,
}

class UploadPhoto extends Component {


    constructor(props)
    {
        super(props);
        this.state = {
            currentFile: null,
            activeLoading: false,
            filesToUpload: [],
            eventName :""

        }
        this.uploadButtonRef = React.createRef();
    }

	componentDidMount() {
        if(this.props.selectedEventId != null)
        {
            this.setState({
                eventName: this.props.selectedEventName,
                eventId: this.props.selectedEventId
            });
        }
    }

    onInputChange = (e) => {

        Resizer.imageFileResizer(
            e.target.files[0],
            300,
            300,
            'JPEG',
            70,
            0,
            uri => {
                const thumnailFile = new File([uri], 'thumbnail.jpg', { type: 'image/jpeg' })
                this.setState({currentThumbnail: thumnailFile});
                this.uploadButtonRef.current.disabled = !uri != '';

            },
            'blob',
            200,
            200,
        );

        Resizer.imageFileResizer(
            e.target.files[0],
            1280,
            1280,
            'JPEG',
            100,
            0,
            uri => {
                const imageFile = new File([uri], 'thumbnail.jpg', { type: 'image/jpeg' })
                this.setState({currentFile: imageFile});
                this.uploadButtonRef.current.disabled = !uri != '';

            },
            'blob',
            200,
            200,
        );
    }

      // called every time a file's `status` changes
     handleChangeStatus = ({ meta, file }, status) => { console.log(status, meta, file) }

        // receives array of files that are done uploading when submit button is clicked
     handleSubmit = (files, allFiles) => {
            console.log(files.map(f => f.meta))
            allFiles.forEach(f => f.remove())
        }


    upload = (e) => {
        e.preventDefault();
        this.setState({activeLoading:true});

    }

    handleFinishedUpload = async info => {
        /*console.log('File uploaded with filename', info.filename)
        console.log('Access it on s3 at', info.fileUrl)*/
        new Promise((resolve) => {
                Resizer.imageFileResizer(
                    info.file,
                    300,
                    300,
                    'JPEG',
                    70,
                    0,
                    uri => {
                        const imageFile = new File([uri], 'thumbnail-'+info.filename, { type: 'image/jpeg' });
                        //console.log(imageFile)
                        uploadFile(imageFile, config2)
                            .then(data => info.thumbnail = data.location)
                            .catch(err => console.error(err))
                        info.thumbnail = imageFile;
                        //info.type = "original";
                        console.log(info)
                        var files = this.state.filesToUpload;
                        files.push(info);
                        this.setState({filesToUpload:files});
                    },
                    'blob',
                );
        });

      }

    handleSave = () => {
        if(this.state.eventName == "")
        {
            this.setState({error:"Ingrese nombre del evento"});
            return;
        }

        if(this.state.filesToUpload.length == 0)
        {
            this.setState({error:"Suba alguna foto al evento antes de guardar"});
            return;
        }

        this.setState({error:""});

        console.log(this.state.filesToUpload)

        if(this.props.selectedEventId == null)
        {
            //this.state.filesToUpload
            this.props.handleInsert(this.state.eventName, this.state.filesToUpload, this.props.token);
        }else{
            //this.state.filesToUpload
            this.props.handleAddPhotos(this.props.selectedEventId, this.state.filesToUpload, this.props.token);
        }

    }

    DeletePhoto = (e, toDeleteFile) => {
        e.preventDefault();
        var files = this.state.filesToUpload;
        this.setState({
            filesToUpload: files.filter(file => file.filename != toDeleteFile)
        });
    }


	render() {
		return (
				<Paper
						style={{
							width: "80%",
							padding: "20px",
							margin: "10% auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							<form>
								<h2>Crear Evento</h2>

								<TextField
									id="standard-basic"
									label="Nombre"
									multiline
									rowsMax="4"
									style={{ marginBottom: "20px", width: "100%" }}
									value={this.state.eventName}
                                    onChange={e =>{
                                                if(this.props.selectedEventId == null)
                                                    this.setState({ eventName: e.target.value })
                                                }
                                             }
								/>
								<br />

                                        <DropzoneS3Uploader
                                            onFinish={this.handleFinishedUpload}
                                            s3Url="https://solanas.s3.sa-east-1.amazonaws.com/"
                                            maxSize={1024 * 1024 * 2}
                                            upload={uploadOptions}
                                            accept="image/*"
                                            style={{width:"100%",minHeight:"250px", border:"4px dashed ", borderColor:"rgb(0, 173, 238)"} }
                                        >

                                            <UploadDisplay onDelete={this.DeletePhoto}/>
                                        </DropzoneS3Uploader>

							</form>
                            <br/>
                            <h5>{this.state.error}</h5>
							<Button
								onClick={this.handleSave}
								type="submit"
								color="primary"
								variant="contained"
								style={{ backgroundColor: "#00adee" }}
							>
								Guardar
							</Button>
							<Button onClick={this.props.handleClose} color="primary">
								Cerrar
							</Button>
						</div>
					</Paper>
		);
	}
}
export default UploadPhoto;
